import { pipe, map, filter, head } from 'ramda'

export default (tags = []) =>
  pipe(
    filter(t => t.kind === 'theater'),
    map(({ name }) => name),
    head,
  )(tags || [])
